<template>
  <div class="page-jobs padding-b-75">
    <div class="container">
      <p class="job-listings-mini-title">open for all</p>
      <p class="job-listings-title">
        We're hiring for the following jobs at Gunspring
      </p>
      <p v-if="$store.getters.isAdmin"># Job ID : {{ data.job_id }}</p>
      <router-link :to="{ name: 'careerslist' }" class="request-demo-button hero-button">Search Jobs</router-link>
      <div v-if="$store.getters.isAdmin"></div>
      <div v-if="isEdit" style="text-align: right">
        <button
          href="#"
          class="btn-jobs"
          style="background-color: blue; margin: 0px 5px"
          @click="saveJob"
        >
          save
        </button>
        <button
          href="#"
          class="btn-jobs"
          style="background-color: red; margin: 0px 5px"
          @click="
            isEdit = false;
            dataRequest = data;
          "
        >
          cancel
        </button>
      </div>
      <div v-else style="text-align: right">
        <button
          v-if="$store.getters.isAdmin"
          href="#"
          class="btn-jobs"
          style="background-color: grey; margin: 0px 5px"
          @click="isEdit = true"
        >
          edit
        </button>
        <button
          v-if="$store.getters.isAdmin"
          href="#"
          class="btn-jobs"
          style="background-color: red; margin: 0px 5px"
          @click="deleteJob"
        >
          delete
        </button>
      </div>
      <div class="job-listing-full">
        <div class="row">
          <div
            class="col-xl-10 col-lg-10 col-md-12 order-xl-1 order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-input
              v-if="isEdit"
              v-model="data.title"
              class="job-listing-full-title job-title mb-3"
            ></b-form-input>
            <p v-else class="job-listing-full-title job-title">
              {{ data.title }}
            </p>
            <b-form-input
              v-if="isEdit"
              v-model="data.location"
              class="job-listing-full-location mb-3"
            ></b-form-input>
            <p v-else class="job-listing-full-location">{{ data.location }}</p>
            <!-- content -->
            <editor v-if="isEdit" v-model="data.description" />
            <div v-else v-html="data.description"></div>
            <p class="job-listing-apply-title">Apply for this job</p>
            <form class="job-form-apply" @submit.prevent="sendEmailJob">
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label for="job-form-full-name">Full name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="job-form-full-name"
                      v-model="jobfullname"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="job-form-email-address">Email address</label>
                    <input
                      type="email"
                      class="form-control"
                      id="job-form-email-address"
                      required
                      v-model="jobemail"
                    />
                  </div>
                  <div class="form-group">
                    <label for="job-form-resume-file">Resume file</label>
                    <b-form-file
                      v-model="jobfile"
                      accept="application/pdf"
                      placeholder="Choose a pdf file or drop it here..."
                      drop-placeholder="Drop file here..."
                      class="form-control-file"
                      id="job-form-resume-file"
                    >
                    </b-form-file>
                  </div>
                  <div class="form-group" v-if="$store.getters.isAdmin">
                    <label for="job-form-email-address">To Email Debug</label>
                    <input
                      type="email"
                      class="form-control"
                      id="job-form-email-address"
                      v-model="debugemail"
                    />
                  </div>
                </div>
              </div>
              <div class="jobs-disclaimer">
                <p class="jobs-disclaimer-text">
                  When you apply for a position at Gunspring, we use the
                  personal data you provide for the purpose of assessing your
                  application, considering you for future positions and carrying
                  out human resources functions in accordance with applicable
                  law. Gunspring will share the personal data you supply during
                  the application process with internal human resources
                  professionals as well as professionals in our business
                  functions who are participating in the application and
                  interview process. The personal data that may be collected,
                  shared, and/or processed for this purpose includes your name,
                  title, company name, email address, telephone number, postal
                  address, language, resume, cover letter, age, education,
                  professional history and contact details. It is in Gunspring's
                  legitimate business interests to be able to review the
                  qualifications of prospective employees and perform human
                  resources functions with regard to our employees. For further
                  details see the
                  <router-link :to="{ name: 'privacy' }"
                    >Gunspring Privacy Statement.</router-link
                  >
                </p>
                <p class="job-listing-full-label">Acceptance</p>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="job-form-accept-check"
                    required
                  />
                  <label class="form-check-label" for="job-form-accept-check">
                    By clicking on 'I accept' I consent to the above terms.
                  </label>
                </div>
              </div>
              <div class="row">
                <div
                  v-if="!hasSent"
                  class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-3"
                >
                  <button
                    type="submit"
                    class="request-demo-button hero-button"
                  >
                    Apply
                  </button>
                </div>
                <div v-else class="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-9">
                  <p
                    class="jobs-application-sent"
                    :style="{ display: 'block' }"
                  >
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                    Application sent!
                  </p>
                </div>
              </div>
            </form>
          </div>
          <div
            class="col-xl-2 col-lg-2 col-md-12 order-xl-2 order-lg-2 order-md-1 order-sm-1 order-1"
          >
            <p class="job-listing-full-time text-right">
              {{ getTime(data.created) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from "./Editor";
export default {
  components: {
    Editor,
  },
  data() {
    return {
      data: {
        description: "",
        created: "",
        title: "",
        location: "",
      },
      dataRequest: {},
      isEdit: false,
      jobfile: null,
      jobemail: null,
      jobfullname: null,
      hasSent: false,
      debugemail: null,
    };
  },
  async mounted() {
    console.log(this.$route.params.job_id)
    let res = await this.$store.dispatch("getJob", this.$route.params.job_id);
    this.data = res.data;
    this.dataRequest = res.data;
  },
  methods: {
    formatTime(time) {
      switch (typeof time) {
        case "number":
          break;
        case "string":
          time = +new Date(time);
          break;
        case "object":
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      var time_formats = [
        [60, "seconds", 1], // 60
        [120, "1 minute ago", "1 minute from now"], // 60*2
        [3600, "minutes", 60], // 60*60, 60
        [7200, "1 hour ago", "1 hour from now"], // 60*60*2
        [86400, "hours", 3600], // 60*60*24, 60*60
        [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
        [604800, "days", 86400], // 60*60*24*7, 60*60*24
        [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
        [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
        [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
        [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
        [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      var seconds = (+new Date() - time) / 1000,
        token = "ago",
        list_choice = 1;

      if (seconds == 0) {
        return "Just now";
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "from now";
        list_choice = 2;
      }
      var i = 0,
        format;
      while ((format = time_formats[i++]))
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      return time;
    },
    getTime(utcSeconds) {
      var setEpoch = new Date(0);
      var dateCreated = new Date(setEpoch.setUTCSeconds(utcSeconds));
      var dateNow = new Date();
      var difference = dateNow - dateCreated;
      return this.formatTime(new Date(Date.now() - difference));
    },
    saveJob() {
      this.$store
        .dispatch("editJob", this.dataRequest)
        .then((data) => {
          data.status == 200
            ? (this.isEdit = false)
            : alert("error, when saving data");
          this.isEdit = false;
        })
        .catch((error) => console.log(error));
    },
    deleteJob() {
      this.$store
        .dispatch("deleteJob", this.data)
        .then((data) => {
          return data.status == 204
            ? this.$router.push({ name: "careers" })
            : alert("error, when delete data");
        })
        .catch((error) => console.log(error));
    },
    sendEmailJob() {
      var Form = new FormData();
      console.log(this.data.title)
      Form.append("resume_file", this.jobfile);
      Form.append("email", this.jobemail);
      Form.append("email_debug", this.debugemail);
      Form.append("full_name", this.jobfullname);
      Form.append("job_title", this.data.title);
      Form.append("job_id", this.data.job_id);

      this.$store
        .dispatch("emailJob", Form)
        .then((data) => {
          if (data.status == 200) {
            this.hasSent = true;
            this.jobfile = [];
            this.jobemail = "";
            this.jobfullname = "";
            this.debugemail = "";
          }
        })
        .catch((error) => {
          alert(
            `error sending email ${error.response.data.message}, please refresh the page`
          );
          this.jobfile = [];
          this.jobemail = "";
          this.jobfullname = "";
          this.debugemail = "";
        });
    },
  },
};
</script>